<template>
    <div class="hotkey-detail">
        <div class="col-md-12">
            <h3>Xử lý với khách hàng: <b>{{ customer.name }}</b></h3>
            <h4>Số điện thoại: <b>{{ customer.phone }}</b></h4>
        </div>

        <div class="col-md-12 d-flex justify-content-end">
            <el-date-picker
                v-model="deadline"
                type="datetime"
                size="large"
                placeholder="Chọn deadline"
                :picker-options="pickerOptions"
            ></el-date-picker>
        </div>

        <div class="col-md-12 mb-3 mt-5" :key="id">
            <div class="form-group mb-1">
                <el-input
                    type="textarea"
                    placeholder="Nhập nội dung công việc cần giao..."
                    v-model="task_content"
                    :rows="8"
                    class="task-textarea"
                ></el-input>
            </div>
        </div>

        <span slot="footer" class="dialog-footer d-flex justify-content-end mr-2 mt-5">
            <el-button style="width: 80px" @click="colse">Hủy</el-button>
            <el-button
                style="color: #FFFFFF; width: 80px"
                :style="isDisabled ? 'background-color: rgb(125 105 189)' : 'background-color: #472F92'"
                :disabled="isDisabled || loading"
                @click="CreateTask"
            > <i v-if="loading" class="el-icon-loading"></i> Lưu</el-button>
        </span>
    </div>
</template>

<script>
import { CREATE_TASK_WITH_CUSTOMER } from '@/core/services/store/customer/customer.module'
import moment from "moment-timezone";

export default {
    name: 'DialogHandleCreateTask',
    props: {
        customer: { type: Object, default: {} },
        is_show: { type: Boolean, default: false },
    },
    data() {
        return {
            task_content: '',
            deadline: '',
            loading: false,
            pickerOptions: {
                disabledDate(time) {
                    const now = new Date();
                    const selectedDate = new Date(time);
                    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                    return selectedDate < startOfToday;
                }
            }
        }
    },

    computed: {
        isDisabled() {
            return !(this.task_content.trim() && this.deadline );
        }
    },

    watch: {
        is_show: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.clearData();
                }
            },
        },
    },

    methods: {
        CreateTask() {
            this.loading = true;
            if (this.isDisabled) return;

            const contentHtml = this.task_content
                ? this.task_content.replace(/\n/g, '<br>')
                : '';

            const payload = {
                customer_id: this.customer.id,
                content: contentHtml,
                deadline: moment(this.deadline).format('YYYY-MM-DD HH:mm:ss'),
                sale: this.customer.ma_gioi_thieu -100000 ,
                type: 1
            };

            this.$store.dispatch(CREATE_TASK_WITH_CUSTOMER, payload)
            .then((response) => {
                if (response.status === 422) {
                    this.$message({ type: 'warning', message: `${response.message}`, showClose: true });
                    this.loading = false;
                } else {
                    this.$message({ type: 'success', message: 'Tạo task thành công!', showClose: true });
                    this.colse();
                    this.$emit('change-type-new-task', this.customer.id)
                    this.clearData();
                    this.loading = false;
                }
            });
        },

        colse() {
            this.$emit('close');
            this.clearData();
        },

        clearData() {
            this.task_content = '';
            this.deadline = '';
        }
    }
}
</script>

<style scoped>
.task-textarea .el-textarea__inner {
    height: 200px !important;
}
</style>
